<template>
  <div class="af-field__wrapper">
    <div
      v-if="label"
      :class="labelClassList"
      @click.stop="handleClick"
      class="af-field__label"
    >
      {{ label }}
    </div>
    <div :class="classList" @click="handleClick" v-click-outside="handleClickOutside" class="af-field">
      <slot></slot>
    </div>
    <div v-if="showErrorMessage" class="af-field__helper af-field__error">
      {{  errorMessage }}
    </div>
    <div v-else-if="helperText" class="af-field__helper">
      {{  helperText }}
    </div>
    <v-style v-if="altValidIcon">
      .{{ altValidIconClass }}:after {
        mask-image: url({{ altValidIcon }});
        -webkit-mask-image: url({{ altValidIcon }});
      }
    </v-style>
    <v-style v-if="altErrorIcon">
      .{{  altErrorIconClass }}:after {
        mask-image: url({{ altErrorIcon }});
        -webkit-mask-image: url({{ altErrorIcon }});
      }
    </v-style>
  </div>  
</template>

<script>

import vStyle from './vStyle';
import vClickOutside from 'v-click-outside';

export default {

  name: 'field-wrapper',

  components: {
    vStyle
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  props: {
    extraClass: {
      type: String,
      default: null,
    },
    labelExtraClass: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      uniqid: null,
    }
  },

  created() {
    this.uniqid = Math.random().toString(36).substr(2, 12);
  },

  computed: {
    helperText() {
      return this.$parent.helperText;
    },
    showErrorMessage() {
      return this.$parent.showErrorMessage;
    },
    errorMessage() {
      return this.$parent.errorMessage;
    },
    label() {
      return this.$parent.label;
    },
    isPristine() {
      return this.$parent.pristine;
    },
    labelUp() {
      return this.isFocused;
    },
    labelDown() {
      return !this.isFocused && this.isPristine;
    },
    showValidClass() {
      return this.$parent.showValidClass;
    },
    showErrorClass() {
      return this.$parent.showErrorClass;
    },
    isFocused() {
      return this.$parent.focused;
    },
    altValidIcon() {
      return this.$parent.altValidIcon;
    },
    altErrorIcon() {
      return this.$parent.altErrorIcon;
    },
    showValidIcon() {
      return this.$parent.showValidIcon;
    },
    showErrorIcon() {
      return this.$parent.showErrorIcon;
    },
    altErrorIconClass() {
      return `af-field__error--${this.uniqid}`;
    },
    altValidIconClass() {
      return `af-field__valid--${this.uniqid}`;
    },
    classList() {
      return [
        this.showValidClass ? 'af-field--valid' : null,
        this.showErrorClass ? 'af-field--error' : null,
        this.showErrorIcon ? 'af-field__icon--error' : null,
        this.showValidIcon || this.showErrorIcon ? 'af-field__icon' : null,
        this.showErrorIcon ? 'af-field__icon--error' : null,
        this.showValidIcon ? 'af-field__icon--valid' : null,
        this.isFocused ? 'af-field--focused' : null,
        this.showErrorIcon && this.altErrorIcon ? this.altErrorIconClass : null,
        this.showValidIcon && this.altValidIcon ? this.altValidIconClass : null,
        this.extraClass,
      ].filter(e => e).join(' ');
    },
    labelClassList() {
      return [
        this.labelUp ? 'af-field__label--up' : null,
        this.labelDown ? 'af-field__label--down' : null,
        this.labelExtraClass,
      ].filter(e => e).join(' ');
    }
  },

  methods: {
    handleClick() {
      this.$parent.handleClickOnWrapper();
    },
    handleClickOutside() {
      this.$parent.handleClickOutsideWrapper();
    }
  }

}

</script>


